import { ajaxListCategory } from '../functions/ajax-settings.js';


document.addEventListener("DOMContentLoaded", () => {

    ajaxListCategory();

});
